import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const TagMeta: ComponentMeta = {
  componentName: "Tag",
  package: "antd",
  title: "标签",
  description: "用于标记和分类的标签",
  category: ComponentCategory.DATA_DISPLAY,
  visibleInComponentPanel: true,
  icon: "TagsOutlined",
  canHaveChildren: false,
  designToken: {
    fields: [
      { name: "defaultBg", label: "默认背景", type: "color" },
      { name: "defaultColor", label: "默认文字", type: "color" },
    ],
  },
  props: [
    {
      name: "children",
      label: "标签文本",
      type: PropType.STRING,
      bindable: true,
      bindSources: ["state", "record"],
      defaultValue: "标签",
      group: "内容",
    },
    {
      name: "color",
      label: "颜色",
      type: PropType.STRING,
      bindable: true,
      bindSources: ["state", "record"],
      description: "预设颜色或自定义颜色，如：red, #f00",
      group: "样式",
    },
    {
      name: "closable",
      label: "可关闭",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
    {
      name: "closeIcon",
      label: "自定义关闭图标",
      type: PropType.STRING,
      group: "图标",
    },
    {
      name: "visible",
      label: "是否显示",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "状态",
    },
    {
      name: "bordered",
      label: "边框",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "样式",
    },
  ],
  defaultProps: {
    children: "标签",
    color: "default",
  },
  preview: [
    {
      title: "默认标签",
      props: {
        children: "标签",
      },
    },
    {
      title: "状态标签",
      props: {
        color: "green",
        children: "已启用",
      },
    },
    {
      title: "可关闭标签",
      props: {
        color: "blue",
        closable: true,
        children: "筛选条件",
      },
    },
  ],
  docLinks: [
    {
      title: "Tag 文档",
      url: "https://frontend.mishudata.com/uigallery/iframe.html?key=mijadesign-web/components/tag",
      source: "mijadesign",
    },
  ],
  npm: {
    package: "antd",
    exportName: "Tag",
  },
  snippet: {
    componentName: "Tag",
    package: "antd",
    props: { children: "标签" },
  },
};

export const CheckableTagMeta: ComponentMeta = {
  componentName: "Tag.CheckableTag",
  package: "antd",
  title: "可选中标签",
  description: "可点击切换选中状态的标签",
  category: ComponentCategory.DATA_DISPLAY,
  icon: "TagOutlined",
  canHaveChildren: false,
  props: [
    {
      name: "children",
      label: "标签文本",
      type: PropType.STRING,
      defaultValue: "标签",
      group: "内容",
    },
    {
      name: "checked",
      label: "是否选中",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
  ],
  defaultProps: {
    children: "标签",
    checked: false,
  },
  npm: {
    package: "antd",
    exportName: "Tag",
  },
  snippet: {
    componentName: "Tag.CheckableTag",
    package: "antd",
    props: { children: "标签", checked: false },
  },
};
